/**
 * @deprecated import colors from @addi/foundation/dist/web/colors instead
 */
const Yellow = {
    normal: '#ffcc00',
    light: '#fcf6e5',
    skin: '#f5ead9'
};
export default Yellow;
//# sourceMappingURL=yellow.js.map